import { getDataGridURL } from '../utilities/config';

import { parquetMetadata, parquetRead } from 'hyparquet';

const CacheSize = 2;
const cache = [];
const addCache = (queryString, response) => {
    if (cache.length === CacheSize) {
        cache.shift();
    }
    cache.push({ query: queryString, response });
};

const retrieveFromCache = (queryString) =>
    cache.find((entry) => entry.query === queryString);

const fetchDG = async (queryString) => {
    try {
        console.time('dataGridFetch');
        const url = getDataGridURL();
        const res = await fetch(`${url}/v1?query=${encodeURI(queryString)}`);
        console.timeEnd('dataGridFetch');
        if (res.status === 400) {
            const info = await res.json();
            return { error: info?.error || 'V1 HTTP status 400' };
        }
        const arrayBuffer = await res.arrayBuffer();
        return { arrayBuffer };
    } catch (e) {
        return { error: 'V1 API Error' };
    }
};

export const dataGridFetchData = async (query) => {
    const queryString = JSON.stringify(query);
    const existingRequest = retrieveFromCache(queryString);
    if (existingRequest) {
        return existingRequest.response;
    }
    const resp = await fetchDG(queryString);
    let rtn = {};
    if (resp.error) {
        return resp;
    } else if (resp.arrayBuffer) {
        try {
            const metadata = parquetMetadata(resp.arrayBuffer);
            const columns = metadata?.schema?.filter((c) => c.name != 'schema');
            const columnNames = columns.map((c) => c.name);
            await parquetRead({
                file: resp.arrayBuffer,
                columns: [...columnNames],
                rowStart: 0,
                rowEnd: metadata?.num_rows ? Number(metadata.num_rows) : 199,
                onComplete: (data) => {
                    addCache(queryString, { metadata, data });
                    return (rtn = { metadata, data });
                },
            });
        } catch (e) {
            console.log('parquet data handling error', e);
            rtn.error = 'Parquet data handling error';
        }
    }
    return rtn;
};
